import React from 'react';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import styled from 'styled-components';
import useTranslate from '~/hooks/useTranslate';
import { theme } from '~/styles/themes';
import Button, { ButtonType } from '~/components/shared/Button/button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
import { InvoiceTabValue } from '~/Interfaces';
import { getDebtorInvoices } from '~/store/actions/invoiceActions';
import { useHistory } from 'react-router';
import { useWindowProperties } from '@qred/qit-ui';
import InvoicePageHeader from './InvoicePageHeader';
import {
  PaymentMethodBodyContainer,
  PaymentMethodMainContainer,
} from '../Invoice';

export const CustomerServiceHeaderContainer = styled.div<{
  withSubtext?: boolean;
}>`
  width: 100%;
  min-height: 1rem;
  margin-top: 6em;
  margin-bottom: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
`;

export const CustomerSupportQuestion = styled.div<{
  answer?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5em 0em 0em 0em;
`;
export const CustomerSupportAnswer = styled.div<{
  answer?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0em 0em 1.5em 0em;
`;
const ContactUsButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2em 0em 1em 0em;
`;

interface Props {
  onCancelButton?: () => void;
}

const CustomerSupport: React.FC<Props> = (props) => {
  const history = useHistory();
  const translate = useTranslate();
  const dispatch = useDispatch();

  const { isDesktop } = useWindowProperties();

  const { singleInvoice } = useSelector((state: RootState) => state.factoring);

  const openCustomerSupportPage = () => {
    history.push({
      pathname: '/customer-support',
    });
  };

  const onBackButtonClick = () => {
    dispatch(
      getDebtorInvoices(
        singleInvoice.debtorOrgNumber ??
          singleInvoice.debtor.identificationNumber,
        1,
        10,
        InvoiceTabValue.OPEN
      )
    );
    history.push({
      pathname: '/invoices',
    });
  };

  return (
    <PaymentMethodMainContainer>
      <InvoicePageHeader
        languagePicker
        backButtonLabel="Invoices.Invoices"
        onBackButton={onBackButtonClick}
        customerService={isDesktop}
        onCustomerService={openCustomerSupportPage}
        highlightedSection="customerSupport"
      />
      <PaymentMethodBodyContainer style={{ paddingTop: '2em' }}>
        <CustomerServiceHeaderContainer>
          <Typography
            fontWeight={FontWeights.Thick}
            lineHeight={1.5}
            fontSize={1.2}
            color="#444444"
          >
            {translate('Invoices.CustomerService')}
          </Typography>
        </CustomerServiceHeaderContainer>
        <CustomerSupportQuestion>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Bold}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceQuestion1')}
          </Typography>
        </CustomerSupportQuestion>
        <CustomerSupportAnswer answer>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thin}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceAnswer1')}
          </Typography>
        </CustomerSupportAnswer>
        <CustomerSupportQuestion>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Bold}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceQuestion2')}
          </Typography>
        </CustomerSupportQuestion>
        <CustomerSupportAnswer answer>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thin}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceAnswer2')}
          </Typography>
        </CustomerSupportAnswer>
        <CustomerSupportQuestion>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Bold}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceQuestion3')}
          </Typography>
        </CustomerSupportQuestion>
        <CustomerSupportAnswer answer>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thin}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceAnswer3')}
          </Typography>
        </CustomerSupportAnswer>
        <CustomerSupportQuestion>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Bold}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceQuestion4')}
          </Typography>
        </CustomerSupportQuestion>
        <CustomerSupportAnswer answer>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thin}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceAnswer4')}
          </Typography>
        </CustomerSupportAnswer>
        <CustomerSupportQuestion>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Bold}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceQuestion5')}
          </Typography>
        </CustomerSupportQuestion>
        <CustomerSupportAnswer answer>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thin}
            lineHeight={1.5}
            color={theme.colors.newSecondaryGray}
          >
            {translate('Invoices.CustomerServiceAnswer5')}
          </Typography>
        </CustomerSupportAnswer>
        <ContactUsButtonHolder>
          <Button mb={1} type={ButtonType.Secondary}>
            {translate('Onboarding.ContactUs')}
          </Button>
        </ContactUsButtonHolder>
      </PaymentMethodBodyContainer>
    </PaymentMethodMainContainer>
  );
};

export default CustomerSupport;
